// import "jquery-smooth-scroll";
import "jquery.easing";

/*
 *
 * ----------------------------------------------- */
jQuery(function () {
  jQuery(".page-top").on("click", function () {
    $("html, body").stop().animate({ scrollTop: 0 }, 400, "easeOutQuint");

    return false;
  });
});
